/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Planning_Vakanties_FeestdagenInputs */

const nl_planning_vakanties_feestdagen = /** @type {(inputs: Planning_Vakanties_FeestdagenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Feestdagen`)
};

/**

* @param {Planning_Vakanties_FeestdagenInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const planning_vakanties_feestdagen = /** @type {((inputs?: Planning_Vakanties_FeestdagenInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Planning_Vakanties_FeestdagenInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_planning_vakanties_feestdagen(inputs)
});
export { planning_vakanties_feestdagen as "planning.vakanties.feestdagen" }